<template>
  <div class="page-report">
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title
          date
          :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import AnalyticsService from "../../services/analytics.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";

export default {
  name: "CallBackXero",
  components: {
    MaterialSnackbar,
    MaterialLoading
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
    };
  },
  created() {
    if (!this.$route.query.code || !this.$route.query.state) {
      this.snackbar = "danger";
      this.message = "Missing required parameters";
      this.setTimeOutNotification();
      return;
    }
    this.postAuthCodes();
  },
  methods: {
    postAuthCodes() {
      this.showLoader();
      const dataForm = {
        code: this.$route.query.code,
        state: this.$route.query.state,
      }

      AnalyticsService.postAuthCodes(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.$router.push({
              path: '/erp/login-credentials',
              query: { loginXero: 1 }
            });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.mw-500px {
  max-width: 500px !important;
}
</style>
